import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icon } from '@iconify/react';
import { KeyboardArrowLeft } from '@mui/icons-material';
import Carousel from 'react-material-ui-carousel';
import Slideshow from 'react-slidez';
import Slider from 'react-slick';
import AOS from 'aos';
import { useTranslation } from 'react-i18next';
import ResponsivePlayer from '../components/_dashboard/user/VideoShow';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { sliderData, ourServiceData, ourTeamData, ratingData, cartData } from '../DATA/DataText';
import './slick.css';
import 'aos/dist/aos.css';

AOS.init({ once: true });

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    padding: 0,
    margin: 0
  },
  paper: {
    backgroundColor: 'black'
  },
  counter: {
    marginTop: '50px'
  },
  slider: {
    width: '100%',
    height: '700px',
    backgroundColor: 'yellow'
  },
  carousel: {
    width: '100%',
    height: '600px',
    backgroundColor: 'yellow'
  },
  img: {
    width: '100%',
    height: '100%',
    minHeight: 500,
    objectFit: 'cover'
  },
  centerTextSlide: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    opacity: 0.9,
    '& h1': {
      marginTop: 20,
      fontSize: '60px',
      fontWeight: 700,
      color: '#fff',
      fontFamily: 'Oregano, cursive',
      textTransform: 'capitalize'
    },
    '& h3': {
      fontSize: '20px',
      letterSpacing: '1px',
      fontWeight: 400,
      color: 'white',
      marginTop: 15,
      fontFamily: 'Open Sans, sans-serif'
    }
  },
  cardContainer: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width:900px)': {
      marginBottom: 15,
      marginTop: 15
    }
  },
  card: {
    width: '90%',
    height: '100%',
    padding: '20px 10px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '5px',
    transition: 'all 0.1s ease-in',
    '&:hover': {
      boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)'
    }
  },
  TitleSection: {
    fontFamily: 'Oregano, cursive',
    fontSize: '48px',
    fontWeight: 400,
    color: '#F78181',
    marginTop: 100,
    marginBottom: 50,
    textAlign: 'center'
  },
  imgTitle: {
    position: 'absolute',
    top: -20,
    left: '48%',
    width: 30,
    height: 30
  },
  titleCard: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '28px',
    fontFamily: 'Open Sans, sans-serif',
    color: '#F98997',
    marginTop: 20,
    textAlign: 'center',
    '@media (max-width:780px)': {
      marginTop: 10
    }
  },
  descriptionCard: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '15px',
    color: 'grey',
    fontWeight: 400,
    marginTop: 30,
    textAlign: 'center',
    '@media (max-width:780px)': {
      marginTop: 10
    }
  },
  iconCard: {
    fontSize: '3rem',
    transition: 'all 0.5s ease-out',
    color: '#F98997'
  },
  imgTeam: {
    height: 100,
    width: 100,
    objectFit: 'cover',
    borderRadius: '50%'
  },
  imgRating: {
    height: 70,
    width: 200,
    objectFit: 'contain',
    backgroundColor: 'transparent'
  },
  logoNav: {
    width: 120,
    height: 120,
    objectFit: 'contain'
  },
  cardIllustration: {
    height: 400,
    width: '100%',
    backgroundColor: 'transparent'
  },
  imgIllustration: {
    height: '100%',
    width: '100%',
    objectFit: 'contain'
  },
  butterflyContainer: {
    height: 100,
    width: 120,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
    '& h3': {
      zIndex: 2,
      fontSize: '15px',
      fontWeight: 500,
      color: 'white',
      fontFamily: 'Oregano, cursive'
    }
  },
  butterflyImg: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    zIndex: 1
  },
  showService: {
    padding: '10px 20px',
    marginTop: 50,
    fontFamily: 'Oregano, cursive',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 600,
    background: '#f58081',
    letterSpacing: 1,
    borderRadius: 5,
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)',
    opacity: 1,
    transition: 'all 0.1s ease-in',
    '&:hover': {
      opacity: 0.9
    }
  },
  buttonShowmore: {
    color: '#F78181',
    position: 'relative',
    cursor: 'pointer',
    width: 80,
    marginTop: 20,
    transform: 'rotate(-20deg)',
    fontFamily: 'Oregano, cursive',
    '& a': {
      color: '#F78181',
      cursor: 'pointer',
      textDecoration: 'none'
    },
    '&:after': {
      position: 'absolute',
      content: '""',
      display: 'block',
      left: 0,
      top: 25,
      bottom: 0,
      width: '100%',
      height: '1px',
      background: '#F78181'
    },
    '&:hover': {
      animation: '$all 1s forwards'
    }
  },
  divider: {
    display: 'block',
    margin: '80px auto',
    width: '200px',
    height: '2px',
    background: '#F78181'
  },
  textIllustration: {
    fontSize: '17px',
    fontWeight: 300,
    color: '#555',
    marginTop: 10,
    fontFamily: 'Open Sans, sans-serif',
    '@media (max-width:780px)': {
      marginTop: 10
    }
  },
  cardContainerRating1: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#f27474'
  },
  cardContainerRating: {
    padding: '70px 50px',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#f27474'
  },
  cardRating: {
    width: '90%',
    height: '100%',
    padding: '0px 20px',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'all 0.1s ease-in'
  },
  ContainerCart1: {
    backgroundColor: '#fffff',
    position: 'relative',
    overflow: 'hidden'
  },
  ContainerCart2: {
    backgroundColor: '#fffff'
  },
  ContainerCart55: {
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '100px 0px'
  },
  ContainerCart: {
    display: 'flex',
    height: '64px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'calc(178px * 18)',
    animation: '$move 20s linear infinite'
  },
  bslid: {
    width: '128px',
    margin: '20px',
    // perspective: '100px',
    '& img': {
      width: '100%',
      height: '100%',
      minWidth: '128px'
      /* transition: 'transform 1s',
      '&:hover': {
        transform: 'translateZ(20px)'
      } */
    }
  },
  '@keyframes move': {
    '0%': {
      transform: 'translateX(0)'
    },
    '100%': {
      transform: 'translateX(calc(-178px * 9))'
    }
  },
  '@keyframes all': {
    '0%': {
      transform: 'rotate(-20deg)'
    },
    '100%': {
      transform: 'rotate(0deg)'
    }
  },
  '@keyframes fadein': {
    '0%': {
      opacity: 0.1
    },
    '100%': {
      opacity: 1
    }
  }
}));

export default function FirstPage() {
  const classes = useStyles();
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideInterval = useRef();
  const [t, i18n] = useTranslation();

  const Item = (props) => {
    const classes = useStyles();
    return (
      <div
        className={props.counter === props.item.id - 1 ? 'carousel-item anim' : 'carousel-item'}
        onMouseEnter={props.stop}
        onMouseOut={props.start}
        onBlur={props.start}
      >
        <img alt="img" src={props.item.imgUrl} className={classes.img} />
        <div className={classes.centerTextSlide}>
          <img alt="img" src="/static/logo/logoV.png" className={classes.logoNav} />
          <h1>{t(props.item.title)}</h1>
          <h3>{t(props.item.description)}</h3>
        </div>
      </div>
    );
  };

  const startSlideTimer = () => {
    stopSlideTimer();
    slideInterval.current = setInterval(() => {
      setCurrentSlide((currentSlide) =>
        currentSlide < sliderData.length - 1 ? currentSlide + 1 : 0
      );
    }, 5000);
  };

  const stopSlideTimer = () => {
    if (slideInterval.current) {
      clearInterval(slideInterval.current);
    }
  };

  useEffect(() => {
    startSlideTimer();
    return () => stopSlideTimer();
  }, []);

  const PreviousArrow = () => {
    const prev = () => {
      startSlideTimer();
      const index = currentSlide > 0 ? currentSlide - 1 : sliderData.length - 1;
      setCurrentSlide(index);
    };
    return (
      <button className="buttonItem2 prev2" onClick={prev}>
        <KeyboardArrowLeft style={{ fontSize: 100 }} />
      </button>
    );
  };

  const NextArrow = () => {
    const next = () => {
      startSlideTimer();
      const index = currentSlide < sliderData.length - 1 ? currentSlide + 1 : 0;
      setCurrentSlide(index);
    };
    return (
      <button className="buttonItem2 next2" onClick={next}>
        <KeyboardArrowLeft style={{ transform: 'rotate(180deg)', fontSize: 100 }} />
      </button>
    );
  };

  return (
    <div>
      <Grid xs={12} style={{ backgroundColor: '#f4e4e4', marginTop: 80, minHeight: 500 }}>
        <div className="carousel">
          <div
            className="carousel-inner"
            style={{
              transform: `translateX(${
                document.body.dir === 'ltr' ? -currentSlide * 100 : currentSlide * 100
              }%)`
            }}
          >
            {sliderData.map((item, index) => (
              <Item
                key={index}
                item={item}
                counter={currentSlide}
                stop={stopSlideTimer}
                start={startSlideTimer}
              />
            ))}
          </div>
          <PreviousArrow />
          <NextArrow />
        </div>
        {/* <Slider
          autoplay
          infinite
          fade
          dots={false}
          speed={1000}
          arrows
          slidesToShow={1}
          slidesToScroll={1}
          prevArrow={<PreviousArrow />}
          nextArrow={<NextArrow />}
        >
          {sliderData.map((item, key) => (
            <Item key={key} item={item} />
          ))}
        </Slider>
      */}
      </Grid>
      <Grid
        style={{
          backgroundColor: '#fce6e6',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Grid style={{ padding: '90px 10px', maxWidth: 1020 }}>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <h1
              className={classes.TitleSection}
              style={{ position: 'relative', display: 'inline-block', marginTop: 0 }}
            >
              {t('c_u_s')}
              <img alt="img" src="/static/firstPage/msn1.png" className={classes.imgTitle} />
            </h1>
          </Grid>
          <Grid item sm={7} xs={12} style={{ margin: '0px auto' }}>
            <ResponsivePlayer videoUrl="/static/illustrations/nursery.mp4" />
          </Grid>
        </Grid>
      </Grid>
      <Container style={{ overflow: 'hidden' }} maxWidth="lg">
        <Grid
          container
          style={{ marginTop: 150, alignItems: 'center' }}
          className={classes.cardContainer}
        >
          <Grid item xs={12} md={6} className={classes.cardContainer}>
            <Box className={classes.cardIllustration}>
              <img
                alt="img"
                src="/static/ilu/nursery.png"
                className={classes.imgIllustration}
                data-aos="fade-right"
                data-aos-duration="1000"
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6} style={{ paddingLeft: 50 }}>
            <h1
              className={classes.TitleSection}
              style={{
                textAlign: document.body.dir === 'rtl' ? 'right' : 'left',
                marginTop: 0
              }}
            >
              {t('p_u_s')}
            </h1>
            <p data-aos="fade-left" className={classes.textIllustration}>
              {t('v_r_c')}
            </p>
            <p data-aos="fade-left" className={classes.textIllustration}>
              {t('e_b_s')}
            </p>
            <p data-aos="fade-left" className={classes.textIllustration}>
              {t('v_a_d_e_i_a_l_c')}
            </p>
            <p data-aos="fade-left" className={classes.textIllustration}>
              {t('v_p_m_u_s')}
            </p>
            <div className={classes.buttonShowmore}>
              <a data-aos="fade-left" href="/about">
                {t('en_savoir_plus')}
              </a>
            </div>
          </Grid>
        </Grid>
        <h1 className={classes.TitleSection}>{t('nos_services')}</h1>
        <Grid container className={classes.cardContainer} style={{ padding: '50px 0px' }}>
          {ourServiceData.map((row) => (
            <Grid
              item
              xs={12}
              md={6}
              sm={6}
              className={classes.cardContainer}
              style={{ marginBottom: 35 }}
            >
              <div className={classes.card} data-aos="zoom-in" data-aos-duration="1500">
                <Icon icon={row.icon} color={row.color} className={classes.iconCard} />
                <Typography style={{ color: row.color }} className={classes.titleCard}>
                  {t(row.title)}
                </Typography>
                <Typography className={classes.descriptionCard}>{t(row.description)}</Typography>
              </div>
            </Grid>
          ))}
          <Link to="/services" className={classes.showService}>
            {t('voir_plus_de_détails')}
          </Link>
          <Grid xs={12}>
            <div className={classes.divider} />
          </Grid>
        </Grid>
      </Container>
      <Grid container className={classes.cardContainerRating}>
        <Container>
          <Grid container className={classes.cardContainerRating1}>
            {ratingData.map((row) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.cardContainer}
                style={{ backgroundColor: 'transparent' }}
              >
                <Box className={classes.cardRating} data-aos="zoom-in" data-aos-duration="1000">
                  <img alt="img" src={row.imgUrl} className={classes.imgRating} />
                  <Typography className={classes.titleCard} style={{ color: 'white' }}>
                    {row.title}
                  </Typography>
                  <Typography className={classes.descriptionCard} style={{ color: 'white' }}>
                    {row.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Grid>
      <Container>
        <h1 className={classes.TitleSection}>{t('nosréférences')}</h1>
        <Grid container className={classes.ContainerCart2}>
          <div className={classes.ContainerCart55}>
            {cartData.map((row) => (
              <div className={classes.bslid}>
                <img alt="img" src={row.imgUrl} />
              </div>
            ))}
          </div>
        </Grid>
      </Container>
      {/* <Grid container className={classes.ContainerCart1}>
        <div className={classes.ContainerCart}>
          {cartData.map((row) => (
            <div className={classes.bslid}>
              <img alt="img" src={row.imgUrl} />
            </div>
          ))}
        </div>
      </Grid> */}
    </div>
  );
}

/* const Item = (props) => {
  const classes = useStyles();
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <img alt="img" src={props.item.imgUrl} className={classes.img} />
      <div className={classes.centerTextSlide}>
        <img
          data-aos="fade-right"
          data-aos-duration="1000"
          alt="img"
          src="/static/logo/logoV.png"
          className={classes.logoNav}
        />
        <h1 data-aos="fade-right">{props.item.title}</h1>
        <h3 data-aos="fade-right">{props.item.description}</h3>
      </div>
    </div>
  );
}; */
